import application from "application";
import Dispatcher from "Dispatcher";
import BrowserActions from "./data/BrowserActions";
import DevelopmentActions from "data/dev/DevelopmentActions";
import NavigationStore from "data/NavigationStore";
import baseServices from "lib/BaseServices";
import qs from "query_string";

import "./views/styles/application.less";
import LockApi from "data/LockApi";
import hasUnsavedChanges from "data/selectors/hasUnsavedChanges";
import ITDriver from "it/lib/ITDriver";

window.Hybrid = require("jsmodel/Hybrid");

if (process.env.NODE_ENV !== "production") {
    // so it can receive the selection action (before app bootstrap)
    // eslint-disable-next-line no-unused-expressions
    require("data/dev/MocksetStore").default;
}

if (process.env.NODE_ENV !== "production") {
    // this should stay 'require', even after conversion to JS
    const reduxDevToolsHelper = require("data/util/reduxDevToolsHelper").default;
    Dispatcher.register(reduxDevToolsHelper);
}

application.addInitializationPromise(new $.Deferred(d => $(() => d.resolve())).promise());

window.addEventListener("resize", () => Dispatcher.dispatch({type: BrowserActions.RESIZE}));

window.addEventListener("beforeunload", e => {
    if (hasUnsavedChanges() && !baseServices.__mocked && NavigationStore.canPromptExternalNavigation()) {
        e.preventDefault();
        return e.returnValue = "Changes you made may not be saved.";
    }
});

window.addEventListener("unload", () =>
    LockApi.releaseClient());

if (window.location.search !== "") {
    const params = qs.parse();
    window.AB = (params.ab === "b") || (params.ab === "B") ? "B" : "A";
    if ((params.IT != null) || (params.ITmanifest != null)) {
        window.location.hash = "";
        $("head > title").text("HO : " + (params.IT || "IT").trim().split("\n")[0]);
        ITDriver.initialize(params);
    }
    if (params.mock != null) {
        const mockset = $.trim(params.mock);
        if ((mockset === "") || (mockset === "true")) {
            if (window.HybridConfig.mockRoot != null) {
                console.log(`Using default configured mockset: ${window.HybridConfig.mockRoot}`);
            } else {
                console.log("No mockset specified on the URL, nor configured in config.js");
            }
        } else {
            window.HybridConfig.mockRoot = "mocks/" + mockset + "/";
            application.addInitializer(() => Dispatcher.dispatch({
                type: DevelopmentActions.SELECT_MOCKSET,
                mockset,
            }));
        }
        require("mock/lib/mock_config");
    }
} else {
    window.AB = "A";
}

application.initialize();



// WEBPACK FOOTER //
// ./app/initialize.js